import Museo500 from '@assets/fonts/Museo_sans/MuseoSans_500.ttf';
import Museo700 from '@assets/fonts/Museo_sans/MuseoSans_700.ttf';
import Museo300 from '@assets/fonts/Museo_sans/MuseoSans_300.ttf';
import Museo100 from '@assets/fonts/Museo_sans/MuseoSans_100.ttf';

const font300 = {
  fontFamily: 'Museo Sans',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 300,
  src: `local('Museo Sans'), url(${Museo300}) format('truetype')`,
};

const font400 = {
  fontFamily: 'Museo Sans',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `local('Museo Sans'), url(${Museo100}) format('truetype')`,
};

const font500 = {
  fontFamily: 'Museo Sans',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 500,
  src: `local('Museo Sans'), url(${Museo500}) format('opentype')`,
};
const font700 = {
  fontFamily: 'Museo Sans',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: `local('Museo Sans'), url(${Museo700}) format('truetype')`,
};

export default {
  MuiCssBaseline: {
    styleOverrides: {
      '@font-face': font400,
      fallbacks: [
        {
          '@font-face': font300,
        },
        {
          '@font-face': font500,
        },
        {
          '@font-face': font700,
        },
      ],
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      asterisk: {
        color: '#db3131',
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      input: {
        '&:-webkit-autofill': {
          transitionDelay: '9999s',
          transitionProperty: 'background-color, color',
        },
      },
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        marginLeft: 0,
      },
    },
  },
};
